import { https } from 'mk-biz-pc'
const coreApi = https.coreApi

/**
 * 上传图片(封面上传，上传至共享路径)
 * @param data
 * @returns
 */
export const uploadImage = (data: FormData) => {
  return coreApi('POST /file/uploader', { data })
}
